


















import { Vue, Component } from "vue-property-decorator";
import { accountInfoModule } from "@/store/accountInfo";

@Component({})
export default class NavHeader extends Vue {
  mounted() {
    accountInfoModule.getCurrentUserInfo();
  }

  get isAdmin() {
    return accountInfoModule.isAdmin;
  }
  get isLoggedIn() {
    return accountInfoModule.isLoggedIn;
  }
}
